import { useState } from 'react';
import TimeRangeTabs from '../singleBalance/TimeRangeTabs';
import CryptoGraph from './CryptoGraph';
import { CircularProgress } from '@mui/material';
import { toFixedTrunc } from '../../../client/Juno/helpers';
import ActionButtons from '../common/ActionButtons';

const CryptoBalanceExpand = ({ price, actionIcons, name, selected }) => {
    const [graphData, setGraphData] = useState(null);
    const [loading, setLoading] = useState(false);

    return (
        <div className="p-2 ml-3">
            <div className="flex justify-between pl-3 pr-7 py-4">
                <span className="text-4xl font-semibold text-text block">
                    ${toFixedTrunc(price, 2)}
                </span>
                <TimeRangeTabs coinName={name} setData={setGraphData} setLoading={setLoading} />
                <ActionButtons actionIcons={actionIcons} selected={selected} />
            </div>
            {loading ? (
                <div className="min-h-[400px] w-full flex justify-center">
                    <CircularProgress size={'3rem'} className="self-center mb-10 !text-text" />
                </div>
            ) : graphData ? (
                <CryptoGraph
                    height={400}
                    width={'100%'}
                    data={graphData}
                    view="expand"
                    name={name}
                />
            ) : null}
        </div>
    );
};

export default CryptoBalanceExpand;
